module.exports = __webpack_public_path__ + "static/media/passportEnrollment.3553212c.svg";